import { easeInOut, motion, useAnimate, useTransform, type MotionStyle } from "motion/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useContext, useEffect, useState } from "react";
import { ScrollAnimContext } from "@/contexts/ScrollAnimContext";

export default function GuideBall({ delay = 0, hide = false, style }: { delay?: number; hide?: boolean; style?: MotionStyle }) {
  const [visible, setVisible] = useState(false);
  const [scope, animate] = useAnimate();

  // Show the guide ball after the specified delay
  setTimeout(() => {
    setVisible(true);
  }, delay * 1000);

  useEffect(() => {
    if (hide) {
      // animate(scope.current, { opacity: 0, scale: 0 }, { duration: 0.4 });
    }
  }, [hide, animate, scope]);

  const animation = async () => {
    await animate(scope.current, { opacity: 1, scale: 1 }, { duration: 0.4, type: "spring", visualDuration: 0.4, bounce: 0.5 });
    animate(scope.current, { y: 20 }, { duration: 0.5, repeat: Infinity, repeatType: "mirror", ease: "easeInOut", delay: 1 });
  };

  if (visible) {
    animation();
  }

  // Animate disappearing act for chevron
  const scrollYProgress = useContext(ScrollAnimContext);
  const opacity = useTransform(scrollYProgress, [0.52, 0.64], [1, 0], { ease: easeInOut });

  return (
    <motion.div className='w-10 h-10 mx-auto rounded-full' style={style} ref={scope}>
      <button className='btn btn-circle shadow-lg'>
        <motion.div className='h-full w-full' style={{ opacity }}>
          <ChevronDownIcon />
        </motion.div>
      </button>
    </motion.div>
  );
}
